import React, { useContext, useEffect } from "react"
import { Link, Redirect } from "wouter"
import { AuthContext } from "../contexts/auth"
import { whoami } from "../services/api"
import { XCircleIcon } from "@heroicons/react/24/outline"

export default function ConsultalaLogin() {

  // get token from the url
  const [data, setData] = React.useState({ email: '', codice: '', password: '' })
  const [error, setError] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const [urlToken, setUrlToken] = React.useState('')
  const { token, setToken, signOut, setProfile, setIsEmployee } = useContext(AuthContext)


  useEffect(() => {

    setProfile('')
    setToken('')

    const urlParams = new URLSearchParams(window.location.search);
    const tokenUrl = urlParams.get('token');
    const redirectTo = urlParams.get('redirect_to') || '/';
    setUrlToken(tokenUrl);
    console.log(urlParams.get('token'))
    console.log(tokenUrl);
    if (tokenUrl) {
      if(window.localStorage) {
        window.localStorage.clear();
      }
      setLoading(true)
      setError('')
      whoami(tokenUrl).then((res) => {
        console.log(res)
        setToken(tokenUrl)
        setProfile(res)
        setLoading(false)
        window.location.href = redirectTo;
      }).catch((err) => {
        console.error("Errore durante il login:", err)
        if (err.response && err.response.data && err.response.data.error) {
          setError(err.response.data.error);
        } else {
          setError('Si è verificato un errore. Per favore, riprova.');
        }
        setLoading(false);
      });
    }

  }, []);




  return (
    <>
      <div className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8" id="main_bg" style={{minHeight: '100vh'}}>
        
      </div>
    </>
  )
}
